<template>
  <section>
    <div id="contact-us-technical__info-title" class="mb-12">
      <h2 class="text-h2 mb-2">{{ t('title') }}</h2>
      <p class="text-base text-gray-600">
        {{ t('description') }}
      </p>
    </div>
    <div id="contact-us-technical__info-developer" class="mb-12">
      <div class="text-h3 mb-2">
        {{ t('developers') }}
      </div>
      <div>
        <TheArrowLink
          to="https://docs.wise-paas.advantech.com/en"
          :title="t('technical-documentation')"
          target="_blank"
        >
          {{ t('technical-documentation') }}
        </TheArrowLink>
      </div>
      <div class="mt-4">
        <TheArrowLink :to="trainingUrl" :title="t('training')" target="_blank">
          {{ t('training') }}
        </TheArrowLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { trainingUrl } = useWebsiteUrl();
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-jp": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-tw": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-kr": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-americas": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-asia-pacific": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "en-emea": {
    "title": "Get Our Support",
    "description": "If you already have an account and need our support, please try these resources:",
    "developers": "Developers",
    "technical-documentation": "Technical Documentation",
    "training": "Training and Certification"
  },
  "ja-jp": {
    "title": "その他の支援",
    "description": "すでにアカウントをお持ちで、私たちのサポートが必要な場合は、サポートハブをご覧いただくか、以下のリソースをお試しください",
    "developers": "デベロッパー",
    "technical-documentation": "技術文書",
    "training": "トレーニングおよび認定"
  },
  "zh-cn": {
    "title": "获得其他协助",
    "description": "如果您已开通账户并需要支持，请尝试这些资源:",
    "developers": "开发者",
    "technical-documentation": "专业技术文档",
    "training": "培训与认证"
  },
  "zh-tw": {
    "title": "取得其他協助",
    "description": "若您是會員並需要其他協助，請參考這些資源:",
    "developers": "開發者",
    "technical-documentation": "專業技術文件",
    "training": "培訓與認證"
  }
}
</i18n>
